/**
 * Get phone format +7 (000) 000-00-00
 * @param phoneString
 */
export const formatPhoneNumber = (phoneString: string) => {
  const cleaned = phoneString.replace(/^8/, '7').replace(/\D/g, '');
  return cleaned.replace(
    /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/,
    '+$1 ($2) $3-$4-$5',
  );
};
